'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _translate = require('../../language/translate');

var _ExpandableHintComponent = require('./ExpandableHintComponent');

var _ExpandableHintComponent2 = _interopRequireDefault(_ExpandableHintComponent);

var _InputComponent2 = require('./InputComponent');

var _InputComponent3 = _interopRequireDefault(_InputComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders an input component along with a corresponding label.
 * @extends {InputComponent}
 */
var LabelledInputComponent = function (_InputComponent) {
  _inherits(LabelledInputComponent, _InputComponent);

  function LabelledInputComponent() {
    _classCallCheck(this, LabelledInputComponent);

    var _this = _possibleConstructorReturn(this, (LabelledInputComponent.__proto__ || Object.getPrototypeOf(LabelledInputComponent)).call(this));

    _this.defaultColSize = 6;

    _this.state = {
      open: undefined
    };
    return _this;
  }

  _createClass(LabelledInputComponent, [{
    key: 'renderHint',
    value: function renderHint() {
      if (this.state.open === undefined) {
        this.state = {
          open: this.props.hintStatus
        };
      }
      return this.props.hasExpandableHint && this.props.expandableHintContent && this.state.open && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { style: { clear: 'both' } }),
        _react2.default.createElement(
          'div',
          { style: { margin: '20px' } },
          _react2.default.createElement(_ExpandableHintComponent2.default, {
            hintStatus: this.state.open,
            hintId: this.props.expandableHintId,
            hintTitle: this.props.expandableHintTitle,
            hintContent: this.props.expandableHintContent,
            isHintRawHtml: this.props.expandableHintIsRawHtml
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$inputComponent = _extends({}, this.props.inputComponentProps),
          disabled = _props$inputComponent.disabled,
          newObj = _objectWithoutProperties(_props$inputComponent, ['disabled']);

      var colSize = this.props.tugoMq ? 12 : this.props.size ? this.props.size : this.props.mqRadio && this.props.mqRadio === 1 ? 10 : this.defaultColSize;

      var labelCol = _react2.default.createElement(
        _reactBootstrap.Col,
        { sm: colSize, className: this.props.leftIndent ? 'left-padding-40' : '' },
        _react2.default.createElement(
          _reactBootstrap.Grid,
          { fluid: true },
          this.props.hasExpandableHint && this.props.expandableHintContent ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { sm: 2, className: 'tooltip-hint-labelled-input' },
                _react2.default.createElement(_reactBootstrap.Glyphicon, {
                  glyph: 'info-sign',
                  className: 'ingle-form-expandable-hint info-button',
                  'aria-hidden': 'true',
                  onClick: function onClick() {
                    return _this2.setState({ open: !_this2.state.open });
                  }
                })
              ),
              _react2.default.createElement(
                _reactBootstrap.Col,
                { componentClass: _reactBootstrap.ControlLabel, sm: 10, className: 'input-label' },
                _react2.default.createElement('span', {
                  dangerouslySetInnerHTML: {
                    __html: this.props.inputLabel && (0, _translate.t)(this.props.inputLabel)
                  }
                })
              )
            ),
            this.props.tugoMq && this.renderHint()
          ) : _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { componentClass: _reactBootstrap.ControlLabel, sm: 12, className: 'input-label' },
              _react2.default.createElement('span', {
                dangerouslySetInnerHTML: {
                  __html: this.props.inputLabel && (0, _translate.t)(this.props.inputLabel)
                }
              })
            )
          )
        )
      );

      var inputCol = _react2.default.createElement(
        _reactBootstrap.Col,
        { sm: this.props.hideLabel ? 12 : this.props.size ? 12 - this.props.size : this.props.mqRadio ? 2 : this.props.tugoMq ? 8 : this.defaultColSize },
        this.props.isStatic ? _react2.default.createElement(
          this.props.inputComponent,
          _extends({}, this.props.inputComponentProps, {
            field: this.props.inputComponentField
          }),
          this.props.inputComponentChildren
        ) : _react2.default.createElement(
          this.props.inputComponent,
          _extends({}, this.props.inputComponentProps, {
            field: this.props.inputComponentField,
            htmlId: '' + this.props.inputId + this.props.dynamicFieldIndex,
            disabled: disabled || (0, _url2.default)('form') === 'read_only',
            tugoMq: this.props.tugoMq,
            applicants: this.props.applicants
          }),
          this.props.inputComponentChildren
        )
      );

      return _react2.default.createElement(
        _reactBootstrap.FormGroup,
        {
          className: 'ingle-form-labelled-input' + (this.props.hasError ? ' has-error' : ''),
          controlId: '' + this.props.inputId + this.props.dynamicFieldIndex,
          validationState: this.props.isStatic ? null : this.generateValidationState(this.props.inputComponentField)
        },
        this.props.tugoMq ? _react2.default.createElement(
          'div',
          null,
          !this.props.hideLabel && _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            labelCol
          ),
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            inputCol
          )
        ) : _react2.default.createElement(
          'div',
          null,
          !this.props.hideLabel && labelCol,
          inputCol
        ),
        !this.props.tugoMq && this.renderHint()
      );
    }
  }]);

  return LabelledInputComponent;
}(_InputComponent3.default);

exports.default = LabelledInputComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/LabelledInputComponent.jsx
// module id = 25
// module chunks = 0